import { apiService } from './api';

export interface StudioNotification {
  id: string;
  user_id: string;
  type: 'review_complete';
  payload: {
    game_id: string;
    game_name: string;
    review_id: string;
    status: 'passed' | 'failed' | 'published';
    completed_at: string;
    bundle_version: number | null;
    icon_url: string | null;
    cover_image_url: string | null;
    description: string | null;
    category: string | null;
    issues?: string[];
  };
  read_at: string | null;
  created_at: string;
}

const studioNotificationsService = {
  /**
   * Fetch all unread notifications for the current user.
   */
  async getUnread(): Promise<StudioNotification[]> {
    const response = await apiService.get<{ success: boolean; data: StudioNotification[] }>(
      '/studio-notifications'
    );
    return response.data.data || [];
  },

  /**
   * Mark a notification as read/dismissed.
   */
  async markRead(id: string): Promise<void> {
    await apiService.patch(`/studio-notifications/${id}/read`);
  }
};

export default studioNotificationsService;
